import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/api-support',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/api-support',
      name: 'api-support',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/APISupport.vue')
    }

  ]
};
export default app;
